import { jsx as _jsx } from "react/jsx-runtime";
import { OutlinedInput } from '@mui/material';
import { useCallback } from 'react';
import { default_margin } from 'console/shared/components/fields/type';
export function TextInputWrapper(props) {
    const { onChange, onComplete, ...rest } = props;
    //Может прислать undefined, когда всё сотрут
    const _onChange = useCallback((event) => {
        const value = event.target.value;
        if (value == null) {
            onChange('');
            return;
        }
        onChange(value);
    }, [onChange]);
    const _onComplete = useCallback((e) => {
        if (e.key === 'Enter') {
            onComplete?.(e);
        }
    }, [onComplete]);
    return (_jsx(OutlinedInput, { margin: default_margin, onKeyDown: _onComplete, ...rest, onChange: _onChange }));
}
